import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Sidebar.css";
import {
  Folder,
  ChevronDown,
  ChevronRight,
  Activity,
  History,
  Car,
  UserCheck,
  Mail,
  LogOut,
  UserX,
  MessageCircle ,
  Search
} from "lucide-react";
import { HiUserGroup } from "react-icons/hi2";
import { PiDroneBold } from "react-icons/pi";
import { IoMdCompass } from "react-icons/io";
import { adminLogout } from "../Apis/AdminApis";
import pavamanFullLogo from "../images/LargeTile.scale-150.png";
import collapsedPavamanLogo from "../images/LargeTile.scale-150.png";
import { UserCircle } from "lucide-react"; 
import { RiAdminFill } from "react-icons/ri";
import vehicleIcon from "../images/vehicle.png";
import { exitAdminView } from "../Apis/SuperadminApis";
import { getUnreadCount } from "../Apis/ChatApis";

const Sidebar = ({ unreadMessageCount }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showTeams, setShowTeams] = useState(false);
  const [showAdmins, setShowAdmins] = useState(false);
  const [showDroneMenu, setShowDroneMenu] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false); 
  const [userRole, setUserRole] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [isViewingAsAdmin, setIsViewingAsAdmin] = useState(false);
  const [viewAsAdminName, setViewAsAdminName] = useState("");
  const [viewAsAdminLogo, setViewAsAdminLogo] = useState("");
const [isDgcaCompany, setIsDgcaCompany] = useState(false);

  const handleClick = (path) => {
    if (path) navigate(path);
  };

const handleLogout = async () => {
  const response = await adminLogout();

  if (!response?.error) {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  } else {
    console.error(response.error);
     navigate("/login");
  }
};

  const isDroneRoute =
    location.pathname === "/admin/mission/events" ||
    location.pathname === "/admin/all/pilots-vehicles/history" ||
    location.pathname === "/admin/pilots/vehicles"||
  location.pathname === "/admin/pilot-drone-quick-search";

  const isTeamsRoute =
    location.pathname.startsWith("/admin/teams");
    // location.pathname === "/admin/suspend-pilots";

  const isAdminsRoute =
    location.pathname.startsWith("/superadmin/add-admin") ||
    location.pathname.startsWith("/superadmin/view-all-admins");

const [localUnread, setLocalUnread] = useState(0);

useEffect(() => {
  if (
    unreadMessageCount === undefined &&
    !(userRole === "superadmin" && isViewingAsAdmin)
  ) {
    const fetchUnread = async () => {
      const res = await getUnreadCount();

      if (!res.error) {
        setLocalUnread(res.total_unread);
      }
    };

    fetchUnread();
  }
}, [unreadMessageCount, userRole, isViewingAsAdmin]);

  useEffect(() => {
    setShowDroneMenu(isDroneRoute);
    setShowTeams(isTeamsRoute);
    setShowAdmins(isAdminsRoute);
  }, [location.pathname]);

useEffect(() => {
  const sessionData = JSON.parse(
    sessionStorage.getItem("session_data") || "{}"
  );

  const role =
    sessionData?.role ||
    sessionStorage.getItem("adminRole") ||
    localStorage.getItem("adminRole");

  const storedLogo = localStorage.getItem("admin_logo");
  const storedCompanyName = localStorage.getItem("company_name");

  const viewingAsAdmin =
    localStorage.getItem("view_as_admin_id") ||
    sessionStorage.getItem("view_as_admin_id");

  const viewingAdminName =
    localStorage.getItem("view_as_admin_name") ||
    sessionStorage.getItem("view_as_admin_name");

  const viewingAdminLogo =
    localStorage.getItem("view_as_admin_logo") ||
    sessionStorage.getItem("view_as_admin_logo");

  const storedDgcaStatus =
    localStorage.getItem("is_dgca_company") ||
    sessionStorage.getItem("is_dgca_company");

  setUserRole(role);

  // Superadmin: always DGCA
  // Superadmin viewing an Admin: use the Admin's DGCA status
  // Normal Admin: use its own DGCA status
  setIsDgcaCompany(
    role === "superadmin" && !viewingAsAdmin
      ? true
      : storedDgcaStatus === "true" ||
        sessionData?.is_dgca_company === true
  );

  setIsViewingAsAdmin(!!viewingAsAdmin);
  setViewAsAdminName(viewingAdminName || "");
  setViewAsAdminLogo(viewingAdminLogo || "");

  if (viewingAsAdmin && viewingAdminLogo) {
    setCompanyLogo(viewingAdminLogo);
    setCompanyName(viewingAdminName);
  } else if (storedLogo && storedLogo !== "null") {
    setCompanyLogo(storedLogo);
    setCompanyName(storedCompanyName);
  }
}, [location.pathname]);

 const handleExitAdminView = async () => {
  try {
    const response = await exitAdminView();

    if (response.error) {
      console.error(response.error);
      return;
    }
    localStorage.removeItem('view_as_admin_id');
    localStorage.removeItem('view_as_admin_name');
    localStorage.removeItem('view_as_admin_logo');
   localStorage.removeItem("is_dgca_company");
localStorage.removeItem('is_superadmin_company');

    sessionStorage.removeItem('view_as_admin_id');
    sessionStorage.removeItem('view_as_admin_name');
    sessionStorage.removeItem('view_as_admin_logo');
    sessionStorage.removeItem("is_dgca_company");
    sessionStorage.removeItem('is_superadmin_company');
    navigate('/superadmin/dashboard');

  } catch (error) {
    console.error("Exit admin view failed:", error);
  }
};

  return (
    <>
     <header className={`sidebar-header ${collapsed ? "header-collapsed" : ""}`}>
      <div className="header-logo-container">
        {userRole === "superadmin" && !isViewingAsAdmin ? (
          <div className="header-brand-side superadmin-logo-only">
            <img
              src={collapsed ? collapsedPavamanLogo : pavamanFullLogo}
              alt="Pavaman Logo"
              className={`header-pavaman-logos ${collapsed ? "collapsed-logo" : ""}`}
            />
            <button
              className="header-collapse-toggle superadmin-toggle"
              onClick={() => setCollapsed(!collapsed)}
            >
              <ChevronRight
                className={`toggle-icon ${collapsed ? "" : "rotated"}`}
                size={20}
              />
            </button>
          </div>
        ) : (
          <>
            <div className="header-brand-side">
              <img
                src={pavamanFullLogo}
                alt="Pavaman Logo"
                className="header-pavaman-logo"
              />
              {!collapsed && (
                <div className="header-brand-text">
                  <span className="header-brand-title">Kapil Future Tech</span>
                  <span className="header-brand-subtitle">Drone Operations</span>
                </div>
              )}
            </div>
            {!collapsed && <div className="header-logo-divider">×</div>}
            <div className="header-company-side">
              {companyLogo ? (
                <img
                  src={companyLogo}
                  alt="Company Logo"
                  className="header-company-logo"
                />
              ) : (
                <div className="header-company-placeholder">
                  {companyName?.charAt(0) || "C"}
                </div>
              )}

              {!collapsed && (
                <div className="header-company-text">
                  <span className="header-company-title">
                    {companyName || (isViewingAsAdmin ? viewAsAdminName : "NewAdmin Company")}
                  </span>
                  <span className="header-company-subtitle">Admin Panel</span>
                </div>
              )}

              <button
                className="header-collapse-toggle"
                onClick={() => setCollapsed(!collapsed)}
              >
                <ChevronRight
                  className={`toggle-icon ${collapsed ? "" : "rotated"}`}
                  size={20}
                />
              </button>
            </div>
          </>
        )}
      </div>
      {userRole === "superadmin" && isViewingAsAdmin && (
        <div className="header-exit-view">
          <button 
            className="exit-admin-btn"
            onClick={handleExitAdminView}
            style={{
              background: '#dc3545',
              color: 'white',
              padding: '6px 12px',
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '500',
              marginRight: '16px'
            }}
          >
            Exit Admin View
          </button>
        </div>
      )}
    </header>

      <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
        <ul className="sidebar-menu">
          <li
            className={`menu-item ${
              location.pathname === "/admin/dashboard" ||
              location.pathname === "/superadmin/dashboard" ? "active" : ""
            }`}
            onClick={() =>
              handleClick(
                userRole === "superadmin" && !isViewingAsAdmin
                  ? "/superadmin/dashboard"
                  : "/admin/dashboard"
              )
            }
            data-tooltip="Dashboard"
          >
            <IoMdCompass size={24} />
            {!collapsed && <span>Dashboard</span>}
          </li>

          <li className={`dropdown-parent ${showDroneMenu ? "expanded" : ""}`}>
            <div
              className="dropdown-title"
              onClick={() => setShowDroneMenu(!showDroneMenu)}
              data-tooltip="Drone Operations"
            >
              <PiDroneBold size={24} />
              {!collapsed && <span>Drone Operations</span>}
              {!collapsed && (
                <ChevronDown
                  size={24}
                  className={`arrow ${showDroneMenu ? "open" : ""}`}
                />
              )}
            </div>

            {showDroneMenu && (
              <ul className="dropdown-menu">
                <li
                  className={location.pathname === "/admin/mission/events" ? "active" : ""}
                  onClick={() => handleClick("/admin/mission/events")}
                >
                  <Activity size={20} className="dropdown-icon" />
                  {!collapsed && "Mission Events"}
                </li>
                <li
                  className={location.pathname === "/admin/all/pilots-vehicles/history" ? "active" : ""}
                  onClick={() => handleClick("/admin/all/pilots-vehicles/history")}
                >
                  <History size={20} className="dropdown-icon" />
                  {!collapsed && "All Pilots & Vehicles"}
                </li>
               <li
  className={location.pathname === "/admin/pilots/vehicles" ? "active" : ""}
  onClick={() => handleClick("/admin/pilots/vehicles")}
>
  <img 
    src={vehicleIcon} 
    alt="Vehicles" 
    className="dropdown-icon custom-vehicle-icon"
  />
  {!collapsed && "Vehicles"}
</li>
 <li
                  className={location.pathname === "/admin/pilot-drone-quick-search" ? "active" : ""}
                  onClick={() => handleClick("/admin/pilot-drone-quick-search")}
                >
                  <Search size={20} className="dropdown-icon" />
                  {!collapsed && "Pilot & Drone Search"}
                </li>
              </ul>
            )}
          </li>
             

          <li className={`dropdown-parent ${showTeams ? "expanded" : ""}`}>
            <div
              className="dropdown-title"
              onClick={() => setShowTeams(!showTeams)}
              data-tooltip="Teams"
            >
              <HiUserGroup size={24} />
              {!collapsed && <span>Teams</span>}
              {!collapsed && (
                <ChevronDown size={24} className={`arrow ${showTeams ? "open" : ""}`} />
              )}
            </div>
            {showTeams && (
              <ul className="dropdown-menu">
                <li className={location.pathname === "/admin/teams/active" ? "active" : ""} onClick={() => handleClick("/admin/teams/active")}>
                  <UserCheck size={20} className="dropdown-icon" />
                  {!collapsed && "Active Team"}
                </li>
                <li className={location.pathname === "/admin/teams/requests" ? "active" : ""} onClick={() => handleClick("/admin/teams/requests")}>
                  <Mail size={20} className="dropdown-icon" />
                  {!collapsed && "Team Requests"}
                </li>
            {(
  // Normal SuperAdmin → always show
  (userRole === "superadmin" && !isViewingAsAdmin) ||

  // SuperAdmin viewing Admin → show only if switched Admin is DGCA
  (userRole === "superadmin" && isViewingAsAdmin && isDgcaCompany) ||

  // Normal Admin → show only if DGCA
  (userRole === "admin" && isDgcaCompany)
) && (
  <li
    className={`menu-item ${
      location.pathname === "/admin/generate-pilot-key"
        ? "active"
        : ""
    }`}
    onClick={() => handleClick("/admin/generate-pilot-key")}
    data-tooltip="Generate Pilot Key"
  >
    <svg
      className="sidebar-icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
        fill="currentColor"
      />
    </svg>

    {!collapsed && <span>Pilot Keys</span>}
  </li>
)}
                {/* <li
  className={`menu-item ${location.pathname === "/admin/pilot-profile-requests" ? "active" : ""}`}
  onClick={() => handleClick("/admin/pilot-profile-requests")}
  data-tooltip="Pilot Profile Requests"
>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
    <path d="M12 14v4m0 0l-2-2m2 2l2-2"/>
  </svg>
  {!collapsed && <span>Pilot Profile Requests</span>}
</li> */}
                {/* <li className={location.pathname === "/admin/suspend-pilots" ? "active" : ""} onClick={() => handleClick("/admin/suspend-pilots")}>
                  <UserX size={20} className="dropdown-icon" />
                  {!collapsed && "Suspend Pilots"}
                </li> */}
              </ul>
            )}
          </li>



          {userRole === "superadmin" && !isViewingAsAdmin && (
  <li className={`dropdown-parent ${showAdmins ? "expanded" : ""}`}>
    <div className="dropdown-title" onClick={() => setShowAdmins(!showAdmins)} data-tooltip="Admins">
      <RiAdminFill size={24} />
      {!collapsed && <span>Admins</span>}
      {!collapsed && <ChevronDown size={24} className={`arrow ${showAdmins ? "open" : ""}`} />}
    </div>
    {showAdmins && (
      <ul className="dropdown-menu">
        <li className={location.pathname === "/superadmin/add-admin" ? "active" : ""} onClick={() => handleClick("/superadmin/add-admin")}>
          <UserCheck size={20} className="dropdown-icon" />
          {!collapsed && "Add Admin"}
        </li>
        <li className={location.pathname === "/superadmin/view-all-admins" ? "active" : ""} onClick={() => handleClick("/superadmin/view-all-admins")}>
          <Mail size={20} className="dropdown-icon" />
          {!collapsed && "View Admin"}
        </li>
        <li 
          className={location.pathname === "/superadmin/profile-requests" ? "active" : ""} 
          onClick={() => handleClick("/superadmin/profile-requests")}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8l-5-5z"/>
            <path d="M15 3v5h5"/>
            <path d="M8 13l2 2 4-4"/>
          </svg>
          {!collapsed && "Profile Edit Requests"}
        </li>
      </ul>
    )}
  </li>
)}

         {userRole === "admin" && (
  <li
    className={`menu-item ${location.pathname === "/admin/profile" ? "active" : ""}`}
    onClick={() => handleClick("/admin/profile")}
    data-tooltip="Profile"
  >
    <UserCircle size={24} />
    {!collapsed && <span>Profile</span>}
  </li>
)}

          <li className={`menu-item ${location.pathname === "/projects" ? "active" : ""}`} onClick={() => handleClick("/projects")} data-tooltip="Projects">
            <Folder size={24} />
            {!collapsed && <span>Projects</span>}
          </li>

         {!(userRole === "superadmin" && isViewingAsAdmin) && (
  <li 
    className={`menu-item ${
      location.pathname === "/admin/messages" || 
      location.pathname === "/superadmin/messages" 
        ? "active" 
        : ""
    }`} 
    onClick={() => handleClick(
      userRole === "superadmin" && !isViewingAsAdmin
        ? "/superadmin/messages"
        : "/admin/messages"
    )} 
    data-tooltip="Messages"
  >
    <MessageCircle size={24} />
    {!collapsed && <span>Messages</span>}

    {(Number(unreadMessageCount ?? localUnread)) > 0 && (
      <span className="message-badge">
        {Number(unreadMessageCount ?? localUnread)}
      </span>
    )}
  </li>
)}

          {userRole === "superadmin" && !isViewingAsAdmin && (
            <li className={`menu-item ${location.pathname === "/admin/dashboard" ? "active" : ""}`} onClick={() => handleClick("/admin/dashboard")} data-tooltip="GCS Dashboard">
              <Activity size={24} />
              {!collapsed && <span>GCS Dashboard</span>}
            </li>
          )}

          <li className="menu-item logout-item" onClick={() => setShowLogoutConfirm(true)} data-tooltip="Logout">
            <LogOut size={24} />
            {!collapsed && <span>Logout</span>}
          </li>
        </ul>
      </aside>

      {showLogoutConfirm && (
        <div className="logout-modal-overlay">
          <div className="logout-modal">
            <h3>Confirm Logout</h3>
            <p>Are you sure you want to logout?</p>
            <div className="logout-actions">
              <button className="cancel-btn" onClick={() => setShowLogoutConfirm(false)}>Cancel</button>
              <button className="confirm-btn" onClick={() => { setShowLogoutConfirm(false); handleLogout(); }}>Logout</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;